import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { Logger, untilDestroyed } from '@app/core';
import { AuthService } from '../../services/auth.service';
import { SharedService } from '@app/shared/services/shared.service';
import { LoaderComponent } from '@app/shared/loader/loader.component';

const log = new Logger('ResetPassword');

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    LoaderComponent
  ]
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  error: string | undefined;
  resetpasswordForm!: FormGroup;
  isLoading = false;
  showSuccessMgs: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private shared: SharedService
  ) {
    this.createForm();
  }

  ngOnInit() {}

  submit() {
    this.error = '';
    this.isLoading = true;
    const submit$ = this.authService.submit(this.resetpasswordForm.value);
    submit$
      .pipe(
        finalize(() => {
          this.resetpasswordForm.markAsPristine();
          this.isLoading = false;
        }),
        untilDestroyed(this)
      )
      .subscribe(
        data => {
          log.debug(`${data} successfully logged in`);
          // if (data === true) {
          //   this.showSuccessMgs = data;
          // }
          const msgSucc = 'تم إرسال رابط إعادة ضبظ كلمة السر';
          this.showSuccessMgs = true;
          this.shared.toastr.success(this.shared.translate.instant('common.success'), msgSucc);
          // this.router.navigate([this.route.snapshot.queryParams.redirect || '/'], { replaceUrl: true });
        },
        err => {
          const error = err.error;
          log.debug(`reseting password error: ${error}`);
          if (error) {
            if (error.message) {
              this.error = error.message;
            }
          } else {
            this.error = 'Username or Email incorrect.';
          }
        }
      );
  }

  ngOnDestroy() {}

  private createForm() {
    this.resetpasswordForm = this.formBuilder.group({
      email: ['', Validators.email]
    });
  }
}
